export const SET_ANNOUNCEMENT = 'SET_ANNOUNCEMENT';
export const CLEAR_ANNOUNCEMENT = 'CLEAR_ANNOUNCEMENT';

export function setAnnouncement(message, ariaLive = 'polite') {
  return { type: SET_ANNOUNCEMENT, message: message, ariaLive: ariaLive };
}
export function clearAnnouncement() {
  return { type: CLEAR_ANNOUNCEMENT };
}
